// extracted by mini-css-extract-plugin
module.exports = {"button":"FFi6c","icon":"_2BXvM"};